function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccccff"
    },
    id: "DOC-job_x5F_24_1_",
    d: "M17,14H7v-1h10V14z M11,9H7v1h4V9z M17,17H7v1h10V17z M20,10v11.5c0,0.3-0.2,0.5-0.5,0.5h-15 C4.2,22,4,21.8,4,21.5v-19C4,2.3,4.2,2,4.5,2H12c0.5,0,1,0.2,1.3,0.5l6.2,6.2C19.8,9.1,20,9.6,20,10z M19,10c0-0.3-0.1-0.5-0.3-0.7 C18.5,9.1,18.3,9,18,9h-5V4c0-0.3-0.1-0.5-0.3-0.7C12.5,3.1,12.3,3,12,3H5v18h14V10z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgJobs);
export default __webpack_public_path__ + "static/media/img_Jobs.d4c8cc515bd43b6e3d73d313a1a6a984.svg";
export { ForwardRef as ReactComponent };